import { makeStyles } from '@mui/styles';
import Typography from 'apollo-react/components/Typography';
import FileDocuments from 'apollo-react-icons/FileDocuments';
import classNames from 'classnames';
import React from 'react';

import RuntimeFileViewer from './ssRuntimeFileViewer';
import ControlChangesIcon from '../../components/ControlChangesIcon';
import { FCM_CONTAINER_STYLES } from '../../constants/runtime.constants';

const useStyles = makeStyles({
  editorWrapper: {
    display: 'flex',
  },
  editorLabel: {
    marginRight: 15,
  },
  ...FCM_CONTAINER_STYLES,
});

const SSFileViewer = ({
  isEditor,
  isControlHiddenFCM,
  isControlAddedFCM,
  isControlChangedFCM,
  ...props
}) => {
  const classes = useStyles({ isControlAddedFCM });

  if (isEditor) {
    return (
      <div className={classes.editorWrapper}>
        <Typography className={classes.editorLabel}>{props.label || 'ssFileViewer'}</Typography>
        <FileDocuments color="primary" />
      </div>
    );
  }

  if (isControlAddedFCM || isControlChangedFCM) {
    return (
      <div className={classes.changesModeWrapper} data-ss-id={props.id}>
        <div
          className={classNames(classes.control, isControlHiddenFCM ? classes.hiddenControl : '')}
          data-hidden-fcm={isControlHiddenFCM}
        >
          <RuntimeFileViewer {...props} />
        </div>
        {isControlChangedFCM && (
          <div className={classes.changesIcon}>
            <ControlChangesIcon id={props.id} />
          </div>
        )}
      </div>
    );
  }

  if (isControlHiddenFCM) {
    return (
      <div className={classes.hiddenControl} data-hidden-fcm="true">
        <RuntimeFileViewer {...props} />
      </div>
    );
  }

  return <RuntimeFileViewer {...props} />;
};

export default SSFileViewer;
